import Icons from "../../../../components/icons";
import { useUsersContext } from "../../../../context/usersContext";
import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import { useUserInfo } from "../../../../context/user";

const IntegrationTopbar = ({ account_id }) => {
    const { agency } = useUsersContext();
    const navigate = useNavigate()
    const logout = useUserInfo()[2];

    return (
        <div className="w-full py-4 px-3 bg-background border-b border-border flex items-center justify-between">
            <div>
                {agency?.Customization?.logo ? (
                    <img
                        src={agency?.Customization?.logo}
                        alt="logo"
                        className="dark:invert"
                        style={{ maxWidth: "98px", maxHeight: "28px", paddingLeft: "10px" }}
                    />
                ) : (
                    <span className="inline-flex dark:invert"><Icons id="maybeIcon" /></span>
                )}
            </div>
            <div> {window.location.pathname.includes(`/integration-app/sign-up`) ? <p className="text-muted-foreground">
                Already have an account?{" "}
                <button
                    onClick={() => {
                        navigate(`/integration-app/sign-in?id=${account_id}`);
                    }}
                    className="text-foreground font-medium"
                >
                    Sign in
                </button>
            </p> : window.location.pathname.includes(`/integration-app/sign-in`) ? <p className="text-muted-foreground">
                Do not have an account?{" "}
                <button
                    onClick={() => {
                        navigate(`/integration-app/sign-up?id=${account_id}`);
                    }}
                    className="text-foreground font-medium"
                >
                    Sign up
                </button></p> :
                <button
                    onClick={() => logout()}
                    className="flex items-center gap-2 mr-2"
                >
                    <LogoutIcon sx={{ color: "#949fae" }} fontSize="22px" /><span className="text-[#949fae] font-bold">Logout</span>
                </button>}</div>
        </div>
    );
};

export default IntegrationTopbar;
